import React, { Component } from "react";
import DivsPattern from "./skylineDesignPattern";

class Unsubscribe extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isSuccess: false,
      errorMessage: "",
    };
  }

  componentDidMount() {
    // The URL format is: /account/unsubscribe?token=<encrypted_token>
    // URLSearchParams decodes '+' as a space; restore it so the Base64 token stays intact.
    const token = (new URLSearchParams(this.props.location.search).get("token") || "").replace(/ /g, "+");

    if (!token) {
      this.setState({ isLoading: false, errorMessage: "Invalid or missing unsubscribe token." });
      return;
    }

    fetch(process.env.REACT_APP_API_URL + "UpdateUserPrivacyPreferences", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        preference: "Unsubscribe",
        unsubscribeValue: 1,
        token: token,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.Result === "success") {
          this.setState({ isLoading: false, isSuccess: true });
        } else {
          this.setState({
            isLoading: false,
            errorMessage: result.Message || "Failed to unsubscribe. Please try again.",
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: "An error occurred. Please try again later.",
        });
      });
  }

  renderLoading() {
    return (
      <DivsPattern headerText="Unsubscribe">
        <div className="text-center">
          <p>Processing your request…</p>
        </div>
      </DivsPattern>
    );
  }

  renderSuccess() {
    return (
      <DivsPattern headerText="Unsubscribed Successfully">
        <div className="form-label-group">
          <p>You have been successfully unsubscribed from our newsletter and marketing updates.</p>
        </div>
      </DivsPattern>
    );
  }

  renderError() {
    return (
      <DivsPattern headerText="Unsubscribe">
        <div className="form-label-group">
          <p style={{ color: "red" }}>{this.state.errorMessage}</p>
        </div>
      </DivsPattern>
    );
  }

  render() {
    if (this.state.isLoading) return this.renderLoading();
    if (this.state.isSuccess) return this.renderSuccess();
    return this.renderError();
  }
}

export default Unsubscribe;
